import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {Arguments} from '../common/Arguments';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {handleExport} from '../common/ExportDataToExcelComponent';

const PersonalMembers = () => {
	const getApi = Arguments.host + '/society_organization/society/api!memberPersonal.do';
	const personalApi = Arguments.host + '/society_organization/home/api!organizationAndMember.do';
	const [data, setData] = useState([]);
	const [member, setMember] = useState([]);

	useEffect(() => {
		// 由于页面加载时多个接口都用到了 organization_info 表，因此会导致该表被频繁请求，服务器会报错，因此需要将基金会的放在这里
		RealtimeGetMethod(personalApi).then(allData => {
			const checkedData = allData ? allData : [];
			setData(checkedData);
			setMember(checkedData.filter(data => data.organization_id === '1058'));
		});
	}, [getApi]);

	const exportMembers = () => {
		return RealtimeGetMethod(personalApi).then(allData => {
			return allData?.map(
				(
					{
						organization_name,
						member_name,
						member_sex,
						member_mz,
						member_born,
						member_jg,
						member_zzmm,
						member_educational,
						member_special,
						member_research,
						organization_post,
						member_unit,
						member_unit_attribute,
						member_post,
						member_professional,
						member_sfz,
						member_mobile_phone,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'姓名': member_name,
							'性别': member_sex,
							'民族': member_mz,
							'出生日期': member_born,
							'籍贯': member_jg,
							'政治面貌': member_zzmm,
							'文化程度': member_educational,
							'特殊人才': member_special,
							'研究方向': member_research,
							'社团职务': organization_post,
							'工作单位': member_unit,
							'单位性质': member_unit_attribute,
							'职务': member_post,
							'职称': member_professional,
							'身份证号': member_sfz,
							'手机号': member_mobile_phone,
						}
					),
			);
		});
	};

	const exportMethod = () => {
		exportMembers().then(allData => handleExport(allData));
	};

	const ExportJjhMembers = () => {
		exportMembers().then(allData => {
			const filteredData = allData.filter(data => data['组织名称']?.includes('基金会'));
			handleExport(filteredData);
		});
	};

	return (
		<>
			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>社团个人会员：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{data?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => exportMethod()}>【导出】</Button>
				</Col>
			</Row>

			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>基金会个人会员：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{member?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => ExportJjhMembers()}>【导出】</Button>
				</Col>
			</Row>
		</>
	);
};

export default PersonalMembers;
